import Vue from "vue";
import Vuex from "vuex";
import { getPreference } from "../utils/apiFunction";
import { getAccess, clearCookies } from "../utils/helpers";
import userVUEX from "./userVUEX";
import config from "@/utils/config";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginpage: "",
    notifOpen: false,
    skillsModalOpen: false,
  },
  getters: {
    getLoginPage: (state) => state.loginpage,
  },
  mutations: {
    setLoginPage(state, token) {
      state.loginpage = token;
    },
    setNotifOpen(state, value) {
      Vue.set(state, "notifOpen", value);
    },
    setSkillsModalOpen(state, value) {
      Vue.set(state, "skillsModalOpen", value);
    },
  },
  actions: {
    setPath(state) {
      console.log(state.getters.getLoginPage);
      if (state.getters.getLoginPage == "assessment") {
        if (getAccess("assessment") && getAccess("assessment") != "no-access") {
          // console.log(getAccess('assessment'))
          //  window.open("http://localhost:8082/");
          window.open(`${config.assessment}`);
        } else {
          clearCookies();
          // window.open("http://localhost:8080/?from=assessment");
          window.open("https://app.hire3x.com/?from=assessment");
        }
      } else if (
        state.getters.getLoginPage == "recruitment" &&
        (getAccess("recruitment") != "no-access" ||
          getAccess("candidate") != "no-access")
      ) {
        if (
          getAccess("recruitment") &&
          getAccess("recruitment") != "no-access"
        ) {
          // console.log(getAccess('recruitment'))
          // window.open("http://localhost:8083/");
          window.open(`${config.recruitment}`);
        } else if (
          state.getters.getLoginPage == "candidate" &&
          getAccess("candidate") &&
          getAccess("candidate") != "no-access"
        ) {
          // console.log(getAccess('candidate'))
          // window.open('http://localhost:8084/');
          window.open(`${config.candidateBase}/?from=candidate`);
        } else {
          clearCookies();
          // window.open('http://localhost:8080/?from=recruitment');
          window.open("https://app.hire3x.com/?from=recruitment");
        }
      }
      else if (state.getters.getLoginPage == 'candidate') {
        if ((getAccess('candidate') && getAccess('candidate') != 'no-access')) {
          // console.log(getAccess('assessment'))
          //  window.open("http://localhost:8085/");
          window.open("https://app.hire3x.com/login/?from=candidate");
        }
        else {
          clearCookies();
          window.open("https://app.hire3x.com/login/?from=candidate");
        }
      }
      // else if( state.getters.getLoginPage == 'candidate' && getAccess('candidate'))
      // window.open("http://localhost:8084/");
      else {
        clearCookies();
        // window.open(`http://localhost:8080/login/?from=${state.getters.getLoginPage}`)
        // window.open(`http://localhost:8080/login/?from=${state.getters.getLoginPage}`)
        window.open(`https://app.hire3x.com/login/?from=${state.getters.getLoginPage}`)
      }
    },
    async getPref(state) {
      try {
        const res = await getPreference();
        if (res.status == 200) {
          if (res.data.data.defaultModule != null) {
            if (res.data.data.defaultModule == "assessment") {
              //  window.open("http://localhost:8082/");
              window.open(`${config.assessment}`);
            } else if (res.data.data.defaultModule == "recruitment") {
              // window.open("http://localhost:8083/");
              window.open(`${config.recruitment}`);
            } else if (res.data.data.defaultModule == "candidate")
              // window.open("http://localhost:8084/");
              window.open(`${config.candidateBase}/?from=candidate`);
            else {
              // window.open(`http://localhost:8080/login/?from=${state.getters.getLoginPage}`)
              window.open(
                `https://app.hire3x.com/login/?from=${state.getters.getLoginPage}`,
              );
            }
          } else {
            if (
              getAccess("recruitment") &&
              getAccess("recruitment") != "no-access"
            ) {
              // window.open("http://localhost:8083/");
              window.open(`${config.recruitment}`);
            } else if (
              getAccess("assessment") &&
              getAccess("recruitment") != "no-access"
            ) {
              // window.open("http://localhost:8082/");
              window.open(`${config.assessment}`);
            } else if (
              getAccess("candidate") &&
              getAccess("candidate") != "no-access"
            ) {
              // window.open('http://localhost:8084/');
              window.open(`${config.candidateBase}/?from=candidate`);
            }
            // else if( state.getters.getLoginPage == 'candidate' && getAccess('candidate'))
            // window.open("http://localhost:8084/");
            else {
              window.open(`https://app.hire3x.com/login/?from=${state.getters.getLoginPage}`)
            }
          }
        }
        else {
          window.open(`https://app.hire3x.com/login/?from=${state.getters.getLoginPage}`)
          // window.open(`http://localhost:8080/login/?from=${state.getters.getLoginPage}`)
        }
      } catch (error) {
        window.open(`https://app.hire3x.com/login/?from=${state.getters.getLoginPage}`)
        // window.open(`http://localhost:8080/login/?from=${state.getters.getLoginPage}`)
        console.log(error)
      }
    },

  },
  modules: {
    userVUEX,
  },
});
